import { BOOKING_PORTAL_REFERRER_SOURCE } from "../constants";

export const getAdminPortalUrlWithSource = (path?: string) => {
  const adminPortalUrl = window.__portal_env__
    ? window.__portal_env__.ADMIN_PORTAL_URL
    : process.env?.ADMIN_PORTAL_URL;

  return `${adminPortalUrl}${
    path ? path : ""
  }?${BOOKING_PORTAL_REFERRER_SOURCE}`;
};
